import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { useDDL } from '@americanexpress/react-ddl';
import {
  getIsLoggedInSelector,
  getHasAuthLoadedSelector,
} from '@americanexpress/travel-selectors';

const DigitalDataLayer = ({
  products, isLoggedIn, hasAuthLoaded, cookiesData,
}) => {
  const [isEventTriggered, setIsEventTriggered] = React.useState(false);
  const { updateDDL } = useDDL();

  React.useEffect(() => {
    if (global.BROWSER) {
      const guid = cookiesData?.cookies?.blueboxpublic;

      updateDDL({ name: 'user.authenticated', value: !!isLoggedIn });
      updateDDL({ name: 'user.publicGuid', value: guid });
    }
  }, [hasAuthLoaded, isLoggedIn, cookiesData?.cookies?.blueboxpublic, updateDDL]);

  React.useEffect(() => {
    if (global.BROWSER
      && Object.keys(products?.types)?.length > 0
      && Object.keys(products?.types?.CARD_PRODUCT)?.length > 0
      && !isEventTriggered) {
      const { productsList } = products.types.CARD_PRODUCT;
      const productsDetails = Object.entries(productsList)?.map((entry) => {
        const cardNumber = entry?.[0];
        const details = entry?.[1];
        return {
          id: cardNumber,
          description: details?.product?.description,
          lineOfBusiness: details?.product?.line_of_business_type,
          paymentType: details?.product?.payment_type,
          locale: details?.profile?.locale_preference,
          type: details?.account?.relationship,
          setupDate: details?.status?.account_setup_date,
          status: details?.status?.account_status,
        };
      });
      updateDDL({ name: 'products', value: [...productsDetails] });
      setIsEventTriggered(true);
    }
  }, [products, isEventTriggered, updateDDL]);

  return null;
};

DigitalDataLayer.defaultProps = {
  isLoggedIn: false,
  hasAuthLoaded: false,
};

DigitalDataLayer.propTypes = {
  products: PropTypes.shape({
    types: PropTypes.shape({
      CARD_PRODUCT: PropTypes.shape({
        productsList: PropTypes.shape({}),
      }),
    }),
  }).isRequired,
  isLoggedIn: PropTypes.bool,
  hasAuthLoaded: PropTypes.bool,
  cookiesData: PropTypes.shape({
    cookies: PropTypes.shape({
      blueboxpublic: PropTypes.string,
    }),
  }).isRequired,
};

const mapStateToProps = createStructuredSelector({
  isLoggedIn: getIsLoggedInSelector,
  hasAuthLoaded: getHasAuthLoadedSelector,
});

export { DigitalDataLayer as TestableDigitalDataLayer };

export default connect(mapStateToProps, null)(DigitalDataLayer);
